const BASE_API = process.env.REACT_APP_ROUTE_API;
const token = localStorage.getItem('token');
const headers = {Accept: 'application/json','Content-Type': 'application/json'};

export default {
  checkToken: async () => {
    try {
      const req = await fetch(`${BASE_API}/auth/refresh`, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({ token: token })
      });
      const json = await req.json();
            json.data = json.data ?? [];
            json.statusRetorno = req.status;
      return json;
    } catch (error) {
      console.log(error);
    }
  },
  me: async (token) => {
    try {
      const req = await fetch(`${BASE_API}auth/me?token=` + token, {
        method: 'GET',
        headers: headers,
      });
      const json = await req.json();
            json.statusRetorno = req.status;
      return json;
    } catch (error) {
      console.log(error);
    }
  },
  login: async (email, password) => {
    try {
      const req = await fetch(`${BASE_API}auth/login`, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({ email: email, password: password })
      });
      const json = await req.json();
            json.statusRetorno = req.status;
      return json;
    } catch (error) {
      console.log(error);
    }
  },
  resetPassword: async (email) => {
    try {
      const req = await fetch(`${BASE_API}auth/reset-password`, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({ email: email })
      });
      
      const json = await req.json();
            json.statusRetorno = req.status;
      return json;
    } catch (error) {
      console.log(error);
    }
  },
};